<template>
    <div class="perks-widget">
        <categories @categorySelected="setCategoryId" />

        <offers :category="category" />
    </div>
</template>

<script>
import categories from './Categories.vue';
import offers from './Offers.vue';

export default {
    components: {
        categories,
        offers
    },
    data () {
        return {
            category: ''
        };
    },
    methods: {
        /**
         * Sets the category data from emitted click event
         * @param {object} category - The selected category.
         * @returns {void}
         */
        setCategoryId (category) {
            this.category = category;
        }
    }
}
</script>
